import { brandPrimary, tableTokens } from "@config/theme/tokens";
import { formMenuItem } from "@config/theme/formControls";

/** MUI `palette.primary.main` — same value as Tailwind `theme.extend.colors.primary.DEFAULT` */
export const THEME_PRIMARY_MAIN = brandPrimary;

export const MUI_TAB = {
	SELECTED: {
		TAB_NAME_COLOR: brandPrimary,
		BACKGROUND_COLOR: "rgba(2, 108, 181, 0.08)",
		HOVER_COLOR: "rgba(2, 108, 181, 0.14)",
		INDICATOR_COLOR: brandPrimary,
	},
};

export const MUI_TOOLTIP = {
	TOOLTIP_BACKGROUND_COLOR: "#fff",
	TOOLTIP_COLOR: "#000",
	TOOLTIP_BOX_SHADOW: "0 4px 24px 0 rgba(0,59,157,0.10), 0 1.5px 6px 0 rgba(0,0,0,0.08)",
	TOOLTIP_BORDER_RADIUS: 10,
	TOOLTIP_FONT_SIZE: 12,
	TOOLTIP_PADDING: "10px 16px",
	TOOLTIP_LETTER_SPACING: 0.1,
	TOOLTIP_FONT_FAMILY: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
};

export const MUI_MENU_ITEM = {
	SELECTED: {
		BACKGROUND_COLOR: formMenuItem.selectedBg,
		COLOR: formMenuItem.selectedColor,
		HOVER_COLOR: formMenuItem.selectedHoverBg,
	},
	HOVER: {
		BACKGROUND_COLOR: formMenuItem.hoverBg,
		COLOR: formMenuItem.hoverColor,
	},
	UNSELECTED: {
		BACKGROUND_COLOR: "#e5e7eb",
		COLOR: "#000",
		HOVER_COLOR: "#e5e7eb",
	},
};

export const MUI_STEPPER = {
	CONNECTOR: {
		LINE_BACKGROUND_COLOR: "#e5e7eb",
		ACTIVE_LINE_COLOR: "#003B9D",
		COMPLETED_LINE_COLOR: THEME_PRIMARY_MAIN,
	},
};

/** MUI Table / TableHead / TableCell — aligned with `tableTokens` */
export const MUI_TABLE = {
	HEADER: {
		BACKGROUND: tableTokens.headerBackground,
		COLOR: tableTokens.headerColor,
		FONT_WEIGHT: tableTokens.headerFontWeight,
		FONT_SIZE: tableTokens.headerFontSize,
		LETTER_SPACING: tableTokens.headerLetterSpacing,
		PADDING: tableTokens.headerPadding,
		DIVIDER: tableTokens.headerDivider,
	},
	BODY: {
		PADDING: tableTokens.bodyPadding,
		COLOR: tableTokens.bodyColor,
	},
	BORDER_COLOR: tableTokens.borderColor,
	WRAPPER_RADIUS: tableTokens.wrapperRadius,
	ROW_HOVER: tableTokens.rowHoverBackground,
	WRAPPER_BORDER: tableTokens.wrapperBorder,
};
